import React from 'react';
import styled from 'styled-components';

import HomeSubscribeForm from './HomeSubscribeForm';
import { Para } from './elements';

const Container = styled.section`
  background-image: url('/images/SignupBg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  .container {
    padding: 2.5rem 1.5rem;
  }
`;

const HomeSignup = () => {
  return (
    <Container className="section">
      <div className="container">
        <div className="columns is-vcentered is-variable is-4">
          <div className="column is-6 is-offset-1">
            <h3 className="title has-text-white">
              Thank you for your interest in reaching out! Please fill the form
              below and indicate the reason for your inquiry.
            </h3>
            <Para white>
              We will make sure the right team member responds as soon as
              possible. Have an amazing day filled with love and prosperity!
            </Para>
          </div>
          <div className="column is-4">
            <HomeSubscribeForm />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HomeSignup;
